import { get } from './client';
import { API_ENDPOINTS } from '../config/api';

export interface MerchandiseItem {
  id: number;
  name: string;
  price: number;
  description?: string;
}

export interface Category {
  id: number;
  name: string;
  items: MerchandiseItem[];
}

interface MerchandiseResponse {
  categories: Category[];
  error?: {
    message?: string;
  };
}

export async function getMerchandise() {
  return get<MerchandiseResponse>(API_ENDPOINTS.GET_ITEMS);
}

export default {
  getMerchandise,
};
